import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { JwtAuthService } from '../services/auth/jwt-auth.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private jwtAuth: JwtAuthService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = localStorage.getItem('token');
    let requisicaoAlterada;
    if (token) {
      requisicaoAlterada = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        },
      });
    } else {
      requisicaoAlterada = req;
    }
    return next.handle(requisicaoAlterada);
  }
}
